import { FunctionComponent } from "react";
import "./styles.scss";
import { Icon } from "../Icon";
import setColorName from "../../utils/setColorName";

type Props = {
  preCart: CartProduct[];
  removeItem: (id: string) => void;
  setShowAddedVariants: () => void;
  showAddedVariants: boolean;
};

const AddedVariantsMobile: FunctionComponent<Props> = ({
  preCart,
  removeItem,
  setShowAddedVariants,
  showAddedVariants,
}) => {
  const colors = preCart.reduce((acc: { [key: string]: any[] }, objeto) => {
    let color = objeto.color;
    if (!acc[color]) {
      acc[color] = [];
    }
    acc[color].push(objeto);
    return acc;
  }, {});

  let totalWeightPreCart: number = 0;
  let totalPriceCart: number = 0;

  preCart.forEach(function (item) {
    totalPriceCart += Number(item.manufacturValue) * item.quantity;
  });

  preCart.forEach(function (item) {
    totalWeightPreCart += Number(item.weight.replace(",", ".")) * item.quantity;
  });

  return (
    <section className="chosen_variants_container">
      <button
        onClick={setShowAddedVariants}
        className={`chosen_variants_see ${showAddedVariants && `up_line`}`}
      >
        Variantes elegidas
        <Icon iconName="down_line" />
      </button>
      {showAddedVariants &&
        Object.entries(colors).map(([key, value], index, array) => {
          const isLast = index === array.length - 1;
          return (
            <div className="chosen_variants_by_color">
              <p>
                <span
                  className={`${key === "amarillo" && `span_yellow`} ${
                    key === "rojo" && `span_red`
                  } ${key === "blanco" && `span_white`} ${
                    key === "plata" && `span_silver`
                  }`}
                ></span>
                {setColorName(key)}
              </p>
              <table className="chosen_variants_table">
                <thead>
                  <th>Hilo</th>
                  <th>Largo</th>
                  <th>Cant.</th>
                  <th>Peso</th>
                  <th>Hechura</th>
                  <th></th>
                </thead>
                <tbody>
                  {value.map((product) => {
                    return (
                      <tr>
                        <td>{product.gauge}</td>
                        <td>{product.length}cm</td>
                        <td>{product.quantity}</td>
                        <td>{product.weight}gr</td>
                        <td>
                          {product.manufacturValue == 0
                            ? "Consultar"
                            : "$" + product.manufacturValue}
                        </td>
                        <td>
                          <button
                            className="chosen_variants_edit"
                            onClick={() => removeItem(product._id || "")}
                          >
                            <Icon iconName="trash_icon" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  {isLast ? (
                    <div className="chosen_variants_sumarization">
                      <p className="chosen_variants_subtotal">Subtotal</p>
                      <div className="chosen_variants_sumarization_data">
                        <p className="chosen_variants_subtotal">{"Peso"}</p>
                        <p className="chosen_variants_subtotal">
                          {totalWeightPreCart.toFixed(2)}gr
                        </p>
                      </div>
                      <div className="chosen_variants_sumarization_data">
                        <p className="chosen_variants_subtotal">{"Hechura"}</p>
                        <p className="chosen_variants_subtotal">
                          {" $" + totalPriceCart.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  ) : null}
                </tbody>
              </table>
            </div>
          );
        })}
    </section>
  );
};

export default AddedVariantsMobile;
